import React, { useEffect, useState } from "react";
import { Tag, Tooltip } from "antd";
import { observer } from "mobx-react";
import format from "@app/lib/format";
import moment from "moment";
import { ReportDocumentStatus } from "@app/constants";

import Group from "../../group";
import "./style.scoped.scss";

const ReportDocumentReviewOverview = observer(({ document, readonly, onEdit }) => {
    const [complete, setComplete] = useState({});

    const config = document.reviewConfig;
    const isEnabled = config?.stages?.length > 0;

    useEffect(() => {
        const complete = {};

        let activeStage = config.stages.findIndex(
            (stage) => stage._id === document.review?.stage?._id,
        );
        activeStage = 1;

        if (activeStage < 0 && document.review.status === ReportDocumentStatus.REVIEWED) {
            activeStage = config?.stages.length - 1;
        }

        config.stages.map((stage, i) => {
            if (i < activeStage) {
                complete[stage._id] = true;
            }
        });

        setComplete(complete);
    }, [document]);

    return (
        <Group title="Review" onEdit={!readonly && onEdit}>
            <div className="review">
                {isEnabled &&
                    config.stages.map((stage, i) => {
                        const isLate =
                            stage.deadline &&
                            !complete[stage._id] &&
                            moment(stage.deadline).isBefore();

                        return (
                            <div className="stage" key={stage._id}>
                                <div className="title">
                                    {i + 1}. {stage.title}
                                    {stage.deadline && (
                                        <div className="deadline">
                                            <Tooltip title="Review deadline">
                                                <Tag color={isLate ? "red" : "default"}>
                                                    Deadline: {format.date(stage.deadline)}
                                                </Tag>
                                            </Tooltip>
                                        </div>
                                    )}
                                </div>

                                {stage.escalationEnabled && (
                                    <div className="escalations">
                                        <div className="title">Review Escalations</div>

                                        {stage.escalationTriggers.map((trigger) => {
                                            const isInactive = moment()
                                                .endOf("day")
                                                .isAfter(trigger.triggerDate);

                                            return (
                                                <div className="trigger">
                                                    <div className="days">
                                                        Notify {trigger.days} days before deadline{" "}
                                                        <i>({format.date(trigger.triggerDate)})</i>
                                                        {isInactive && (
                                                            <>
                                                                &nbsp; <Tag>Inactive</Tag>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}

                                <div className="reviewers">
                                    <div className="title">Assigned Reviewers</div>
                                    {stage.reviewers.map((user) => {
                                        return (
                                            <div className="reviewer" key={user._id}>
                                                {user.fullName}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    })}

                {!isEnabled && (
                    <div className="text-center p-10">
                        Review workflow is not enabled for this document
                    </div>
                )}
            </div>
        </Group>
    );
});

export default ReportDocumentReviewOverview;
